import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "深挖专区", to: "/topics" },
  { label: "商业起底", to: "/topics?category=business" },
  { label: "行业内幕", to: "/topics?category=industry" },
  { label: "舆情深挖", to: "/topics?category=opinion" },
  { label: "关于我们", to: "/about" },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.search]);

  const full = `${location.pathname}${location.search}`;
  const isActive = (to: string) => {
    if (to === "/") return location.pathname === "/" && !location.search;
    if (to.includes("?")) return full.startsWith(to.split("?")[0]) && full.includes(to.split("?")[1]);
    return location.pathname === to || (to !== "/" && location.pathname.startsWith(to));
  };

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors duration-300 ${
        scrolled
          ? "border-background-200 bg-background-50/95 backdrop-blur"
          : "border-transparent bg-background-50"
      }`}
    >
      <div className="flex h-16 w-full items-center justify-between gap-4 px-4 md:h-20 md:px-8">
        <Link to="/" className="flex items-center gap-3 whitespace-nowrap">
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-file-search-line text-xl" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-xl font-bold tracking-wide text-foreground-950">
              看料档案
            </span>
            <span className="mt-1 text-[11px] tracking-[0.3em] text-foreground-500">
              深挖 · 起底
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 lg:flex">
          {navItems.map((item) => (
            <Link
              key={item.label}
              to={item.to}
              className={`whitespace-nowrap rounded-md px-3 py-2 text-sm transition-colors ${
                isActive(item.to)
                  ? "bg-primary-50 text-primary-700"
                  : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/topics"
            className="hidden h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600 md:flex"
            aria-label="搜索专题"
          >
            <i className="ri-search-line" />
          </Link>
          <Link
            to="/about#subscribe"
            className="hidden whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            订阅深度周报
          </Link>
          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-700 lg:hidden"
            aria-label="打开菜单"
            aria-expanded={menuOpen}
          >
            <i className={menuOpen ? "ri-close-line text-lg" : "ri-menu-line text-lg"} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 lg:hidden">
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <Link
                key={item.label}
                to={item.to}
                className={`whitespace-nowrap rounded-md px-3 py-3 text-sm transition-colors ${
                  isActive(item.to)
                    ? "bg-primary-50 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/about#subscribe"
              className="mt-2 whitespace-nowrap rounded-md bg-foreground-950 px-3 py-3 text-center text-sm font-medium text-background-50"
            >
              订阅深度周报
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}